export default [
  {
    path: '/funcPuzzleHome',
    name: 'FuncPuzzle',
    meta: {
      title: '我的咨询'
    },
    component: () => import('@/views/funcPuzzle/home/home.vue')
  },
  {
    path: '/funcPuzzleInquiryDetail',
    name: 'FuncPuzzleInquiryDetail',
    meta: {
      title: '咨询详情'
    },
    component: () => import('@/views/funcPuzzle/inquiryDetail/inquiryDetail.vue')
  },
  {
    path: '/funcPuzzleVisitPage',
    name: 'FuncPuzzleVisitPage',
    meta: {
      title: '就诊详情'
    },
    component: () => import('@/views/funcPuzzle/visitPage/visitPage.vue')
  },
  {
    path: '/funcPuzzleChat',
    name: 'FuncPuzzleChat',
    meta: {
      title: 'im聊天'
    },
    component: () => import('@/views/funcPuzzle/chat/chat.vue')
  },
  {
    path: '/funcPuzzlePatientInformation',
    name: 'FuncPuzzlePatientInformation',
    meta: {
      title: '受者信息'
    },
    component: () => import('@/views/funcPuzzle/patientInformation/patientInformation.vue')
  },
  {
    path: '/funcPuzzleCheckRecord',
    name: 'FuncPuzzleCheckRecord',
    meta: {
      title: '检查记录'
    },
    component: () => import('@/views/funcPuzzle/patientInformation/checkRecord.vue')
  },
  {
    path: '/funcPuzzleTherapeuticRegimen',
    name: 'FuncPuzzleTherapeuticRegimen',
    meta: {
      title: '用药方案'
    },
    component: () => import('@/views/funcPuzzle/patientInformation/therapeuticRegimen.vue')
  },
  {
    path: '/funcPuzzleCheckDetail',
    name: 'FuncPuzzleCheckDetail',
    meta: {
      title: '检查详情'
    },
    component: () => import('@/views/funcPuzzle/patientInformation/checkDetail.vue')
  },
  {
    path: '/funcPuzzleCheckIndicators',
    name: 'FuncPuzzleCheckIndicators',
    meta: {
      title: '图表记录'
    },
    component: () => import('@/views/funcPuzzle/checkIndicators/checkIndicators.vue')
  },
  {
    path: '/funcPuzzleCheckIndicatorsImage',
    name: 'FuncPuzzleCheckIndicatorsImage',
    meta: {
      title: '图表记录'
    },
    component: () => import('@/views/funcPuzzle/checkIndicators/checkIndicatorsImage.vue')
  },
  {
    path: '/funcPuzzleInspectionItems',
    name: 'FuncPuzzleInspectionItems',
    meta: {
      title: '图表记录'
    },
    component: () => import('@/views/funcPuzzle/inspectionItems/inspectionItems.vue')
  },
  // 远程协作
  {
    path: '/funcPuzzleMain',
    name: 'FuncPuzzleMain',
    meta: {
      title: '远程协作'
    },
    component: () => import('@/views/funcPuzzle/main/main.vue')
  },
  {
    path: '/funcPuzzlePending',
    name: 'FuncPuzzlePending',
    meta: {
      title: '待处理预约'
    },
    component: () => import('@/views/funcPuzzle/main/pending/pending.vue')
  },
  {
    path: '/funcPuzzleAllReservation',
    name: 'FuncPuzzleAllReservation',
    meta: {
      title: '全部预约'
    },
    component: () => import('@/views/funcPuzzle/main/allReservation/allReservation.vue')
  },
  {
    path: '/funcPuzzleSelectDoctor',
    name: 'FuncPuzzleSelectDoctor',
    meta: {
      title: '选择医生'
    },
    component: () => import('@/views/funcPuzzle/selectDoctor/index.vue')
  },
  {
    path: '/funcPuzzleSelectInstitution',
    name: 'FuncPuzzleSelectInstitution',
    meta: {
      title: '选择医院'
    },
    component: () => import('@/views/funcPuzzle/selectInstitution/index.vue')
  },
  {
    path: '/funcPuzzleDoctorScheduling',
    name: 'FuncPuzzleDoctorScheduling',
    meta: {
      title: '医生排班'
    },
    component: () => import('@/views/funcPuzzle/doctorScheduling/index.vue')
  },
  {
    path: '/funcPuzzleSubmit',
    name: 'FuncPuzzleSubmit',
    meta: {
      title: '确认预约'
    },
    component: () => import('@/views/funcPuzzle/online/submit.vue')
  },
  {
    path: '/funcPuzzleDoctorDetail',
    name: 'FuncPuzzleDoctorDetail',
    meta: {
      title: '医生详情'
    },
    component: () => import('@/views/funcPuzzle/doctorDetail/index.vue')
  },
  {
    path: '/funcPuzzleAddPatient',
    name: 'FuncPuzzleAddPatient',
    meta: {
      title: '添加受者'
    },
    component: () => import('@/views/funcPuzzle/addPatient/index.vue')
  },
  {
    path: '/funcPuzzleSearchPatient',
    name: 'FuncPuzzleSearchPatient',
    meta: {
      title: '添加受者'
    },
    component: () => import('@/views/funcPuzzle/searchPatient/index.vue')
  },
  {
    path: '/funcPuzzleReceivedOrderDetails',
    name: 'FuncPuzzleReceivedOrderDetails',
    meta: {
      title: '订单详情'
    },
    component: () => import('@/views/funcPuzzle/orderDetails/receivedOrderDetails.vue')
  },
  {
    path: '/funcPuzzleOrderDetails',
    name: 'FuncPuzzleOrderDetails',
    meta: {
      title: '订单详情'
    },
    component: () => import('@/views/funcPuzzle/orderDetails/orderDetails.vue')
  },
  {
    path: '/funcPuzzleDiagnosisDetails',
    name: 'FuncPuzzleDiagnosisDetails',
    meta: {
      title: '查看报告'
    },
    component: () => import('@/views/funcPuzzle/diagnosisDetails/diagnosisDetails.vue')
  },
  // 交流学习
  {
    path: '/funcPuzzleConsultation',
    name: 'FuncPuzzleConsultation',
    meta: {
      title: '交流学习'
    },
    component: () => import('@/views/funcPuzzle/consultation/consultation.vue')
  },
  {
    path: '/funcPuzzleConsultationDetail',
    name: 'FuncPuzzleConsultationDetail',
    meta: {
      title: '交流学习'
    },
    component: () => import('@/views/funcPuzzle/consultation/consulationDetail.vue')
  },
  {
    path: '/funcPuzzleAllConsultations',
    name: 'FuncPuzzleAllConsultations',
    meta: {
      title: '交流学习'
    },
    component: () => import('@/views/funcPuzzle/consultation/allConsultations.vue')
  },
  {
    path: '/funcPuzzleAllConsultationApplication',
    name: 'FuncPuzzleAllConsultationApplication',
    meta: {
      title: '交流学习'
    },
    component: () => import('@/views/funcPuzzle/consultation/consultationApplication.vue')
  },
  {
    path: '/funcPuzzleTriage',
    name: 'FuncPuzzleTriage',
    meta: {
      title: '交流学习'
    },
    component: () => import('@/views/funcPuzzle/consultation/triage.vue')
  },
  {
    path: '/funcPuzzlePendingOrder',
    name: 'FuncPuzzlePendingOrder',
    meta: {
      title: '交流学习'
    },
    component: () => import('@/views/funcPuzzle/pendingOrder/pendingOrder.vue')
  },
  {
    path: '/funcPuzzleReferral',
    name: 'FuncPuzzleReferral',
    meta: {
      title: '交流学习'
    },
    component: () => import('@/views/funcPuzzle/referral/referral.vue')
  },
  {
    path: '/funcPuzzleReferralApplication',
    name: 'FuncPuzzleReferralApplication',
    meta: {
      title: '交流学习'
    },
    component: () => import('@/views/funcPuzzle/referral/referralApplication.vue')
  },
  {
    path: '/funcPuzzleReferralDetail',
    name: 'FuncPuzzleReferralDetail',
    meta: {
      title: '交流学习'
    },
    component: () => import('@/views/funcPuzzle/referral/referralDetail.vue')
  },
  // 认证
  {
    path: '/funcPuzzleRealNameAuthentication',
    name: 'FuncPuzzleRealNameAuthentication',
    meta: {
      title: '认证'
    },
    component: () =>
      import(
        '@/views/funcPuzzle/doctorStationed/realNameAuthentication/realNameAuthenticationWrap.vue'
      )
  },
  {
    path: '/funcPuzzleSelectPage',
    name: 'FuncPuzzleSelectPage',
    meta: {
      title: '认证'
    },
    component: () => import('@/views/funcPuzzle/doctorStationed/selectPage/selectPage.vue')
  },
  {
    path: '/funcPuzzleTextareaPage',
    name: 'funcPuzzleTextareaPage',
    meta: {
      title: '认证'
    },
    component: () => import('@/views/funcPuzzle/doctorStationed/textareaPage/textareaPage.vue')
  },
  {
    path: '/funcPuzzleQualificationCertification1',
    name: 'FuncPuzzleQualificationCertification1',
    meta: {
      title: '资质认证'
    },
    component: () =>
      import(
        '@/views/funcPuzzle/doctorStationed/qualificationCertification/qualificationCertification1.vue'
      )
  },
  {
    path: '/funcPuzzleQualificationCertification2',
    name: 'FuncPuzzleQualificationCertification2',
    meta: {
      title: '资质认证'
    },
    component: () =>
      import(
        '@/views/funcPuzzle/doctorStationed/qualificationCertification/qualificationCertification2.vue'
      )
  },
  {
    path: '/funcPuzzleQualificationCertification3',
    name: 'FuncPuzzleQualificationCertification3',
    meta: {
      title: '资质认证'
    },
    component: () =>
      import(
        '@/views/funcPuzzle/doctorStationed/qualificationCertification/qualificationCertification3.vue'
      )
  },
  {
    path: '/funcPuzzlePracticingCertificate',
    name: 'FuncPuzzlePracticingCertificate',
    meta: {
      title: '认证'
    },
    component: () =>
      import('@/views/funcPuzzle/doctorStationed/practicingCertificate/practicingCertificate.vue')
  },
  {
    path: '/funcPuzzleOrgSearch',
    name: 'FuncPuzzleOrgSearch',
    meta: {
      title: '认证'
    },
    component: () => import('@/views/funcPuzzle/doctorStationed/orgSearch/orgSearch.vue')
  },
  {
    path: '/funcPuzzleDeptSearch',
    name: 'FuncPuzzleDeptSearch',
    meta: {
      title: '认证'
    },
    component: () => import('@/views/funcPuzzle/doctorStationed/deptSearch/deptSearch.vue')
  },
  {
    path: '/funcPuzzleReportDetail',
    name: 'FuncPuzzleReportDetail',
    meta: {
      title: '报告详情'
    },
    component: () => import('@/views/funcPuzzle/patientInformation/reportDetail.vue')
  },
  {
    path: '/funcPuzzleWarningDetail',
    name: 'FuncPuzzleWarningDetail',
    meta: {
      title: '预警详情'
    },
    component: () => import('@/views/funcPuzzle/patientInformation/warningDetail.vue')
  },
  {
    path: '/funcPuzzleAIResult',
    name: 'FuncPuzzleAIResult',
    meta: {
      title: 'AI健康解析'
    },
    component: () => import('@/views/funcPuzzle/AI/result.vue')
  },
  {
    path: '/funcPuzzleMedicalRecordDetail',
    name: 'FuncPuzzleMedicalRecordDetail',
    meta: {
      title: '病例详情'
    },
    component: () => import('@/views/funcPuzzle/patientInformation/medicalRecordDetail.vue')
  }
  //
]
